import { boolean, create, Describe } from 'superstruct';

export const DocumentDeleteValidator: Describe<boolean> = boolean();

export function makeDocumenDelete(raw: unknown) {
  try {
    const formResponse = create(raw, DocumentDeleteValidator);
    return formResponse;
  } catch (err) {
    console.error(err);
  }
}
